import { getInputPlaceholderStyle, type InputPlaceholderStyleProps } from '../../styles';

export const getPollPlaceholderStyle = (props: InputPlaceholderStyleProps) => ({
    ...getInputPlaceholderStyle(props),
    '&&::before': {
        left: '50%',
        transform: 'translate(-50%, 0)',
    },
});
